import comp from "./Notification";
export default comp;
